"use client";

import { Link } from "@components/cms/link/Link";
import type { IPartButton } from "@contentful-api/types/contentful";
import { AnalyticsClient } from "@lib/analytics/AnalyticsClient";
import { Button } from "@ecco/ui/button";
import { Flex, type FlexProps } from "@ecco/ui/flex";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import type { FC } from "react";
import { buttonStyle } from "./CallToActionButtons.style";

export type CallToActionPromotion = {
    id: string;
    title?: string;
};

export type CallToActionButtonsProps = FlexProps & {
    callToActions?: IPartButton[];
    promotion?: CallToActionPromotion;
};

export const CallToActionButtons: FC<CallToActionButtonsProps> = ({
    callToActions,
    promotion,
    ...flexProps
}) => {
    if (!callToActions?.length) {
        return null;
    }

    const handleClick = (index: number): void => {
        if (!promotion?.id) {
            return;
        }

        AnalyticsClient.selectPromotion({
            id: promotion.id,
            title: promotion.title,
            index,
        });
    };

    return (
        <Flex gap={[0.5, 2]} wrap="wrap" {...flexProps}>
            {callToActions.map((button, index) => (
                <Button
                    key={button.sys.id}
                    as={Link}
                    variant="standard"
                    link={button.fields.link}
                    rightIcon={<ECCOIcon name="arrow-right" />}
                    {...buttonStyle}
                    onClick={() => handleClick(index)}
                >
                    <span>{button.fields.label}</span>
                </Button>
            ))}
        </Flex>
    );
};
